import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeCoord } from '../models/TypeCoord';
import { Step5 } from '../../../../shared/models/component-messages/diveAT/step5';

@Component({
  selector: 'app-type-coord',
  templateUrl: './type-coord.component.html'
})
export class TypeCoordComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeCoord';
  @Input() parentForm: FormGroup;
  @Input() coord: TypeCoord;
  @Input() disabled: boolean;
  @Input() rule: String;

  public step5 = new Step5();

  constructor() {
  }

  public ngOnInit() {
  }

  public getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
}
